<template>
  <div class="sidebar">
    <div class="sidebar__sticky">
      <div class="wrapper">
        <div class="sidebar__controllers">
          <div class="sidebar__user">
            <RouterLink to="/user">
              <PersonIcon type-img="mini"/>
            </RouterLink>
          </div>
          <div class="sidebar__person-name person-name" v-if="AuthData">
            <h3 class="person-name__first">{{ AuthData.DisplayName }}</h3>
            <h4 class="person-name__second">{{ AuthData.Login }}</h4>
          </div>
        </div>
        <div class="sidebar__exit">
          <ExitIcon @click="signOut"/>
        </div>
      </div>

      <nav class="sidebar__categories navigation-list">
        <NavigationBtn
          link="/"
          title="Проекты"
          :active="activeViewLink == 0"
          :collapsed="minimizeSidebar"
        />
        <!-- <router-link
          :class="{
            'navigation-list__item': true,
            'navigation-list__item_active': activeViewLink == 0
          }"
          to="/"
        >
        <img src="/img/icons/projectIcon.svg" alt="">
          Проекты
        </router-link> -->
        <!-- <router-link
          :class="{
            'navigation-list__item': true,
            'navigation-list__item_active': activeViewLink == item.id || informationListItemId == item.id
          }"
          v-for="(item, idx) in getNavList"
          :key="idx"
          :to="item.slug"
          @mouseenter="informationListBlockVisible(item.slug)"
        >
          <img :src="item.icon" alt="" class="navigation-list__item-icon">
          {{ item.name }}

        </router-link> -->
        <NavigationBtn
        v-for="(item, idx) in getNavList"
        :key="idx"
        :link="item.slug"
        :title="item.name"
        :active="activeViewLink == item.id || informationListItemId == item.id"
        :collapsed="minimizeSidebar"
        />
        <InformationListDrop
          v-if="informationListBlock"
          :InformationList="InformationList"
          @mouseleave="informationListBlockHidden"
        />
      </nav>
      <div class="sidebar__settings">
        <NavigationBtn
          v-if="AuthData.IsAdmin"
          link="/roles"
          title="Безопастность"
          :active="activeViewLink == 9"
          :collapsed="minimizeSidebar"
        />
        <div class="sidebar__arrow" @click="hideShowSidebar">
          <BaseChevron :right="minimizeSidebar"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import router from '@/router'

import BaseChevron from '@/components/ui/BaseChevron.vue'
import NavigationBtn from '@/components/ui/NavigationBtn.vue'
import PersonIcon from '@/components/icons/PersonIcon.vue'
import ExitIcon from '@/components/icons/ExitIcon.vue'
import InformationListDrop from '@/components/elements/InformationListDrop.vue'

// import { searchPolicies } from '@/helpers/policiesValidator.js'

export default {
  name: 'TheSidebar',
  components: {
    BaseChevron,
    NavigationBtn,
    PersonIcon,
    ExitIcon,
    InformationListDrop
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      // получает активный проект из локалсторадж
      store.commit('SetActiveProject', localStorage.getItem('activeProject'))
    })

    const test = () => {
      if (informationListBlock.value) {
        return 3
      }
    }

    const policies = computed(() => store.getters.getPolicies)

    const routerHistoryLocation = computed(() => {
      // получает локацию из роутера
      return router.options.history.location
    })

    // получает логин и имя пользователя для отрисовки
    const AuthData = computed(() => store.getters.getAuthenticatedData)

    const activeViewLink = computed(() => {
      // показывает активную routerLink
      switch (true) {
        case routerHistoryLocation.value.includes('/modules'):
          return 1
        case routerHistoryLocation.value.includes('/products'):
          return 2
        case routerHistoryLocation.value.includes('/news-education'):
          return 8
        case routerHistoryLocation.value.includes('/news'):
          return 3
        case routerHistoryLocation.value.includes('/information'):
          return 3
        case routerHistoryLocation.value.includes('/events'):
          return 4
        case routerHistoryLocation.value.includes('/materials'):
          return 4
        case routerHistoryLocation.value.includes('/application'):
          return 7
        case routerHistoryLocation.value.includes('/roles'):
          return 9
        default: return 0
      }
    })

    const hideShowSidebar = () => {
      // скрывает сайтбар
      store.commit('SetMinimizeSidebar', !minimizeSidebar.value)
    }

    const activeProject = computed(() => {
      return store.getters.getActiveProject
    })

    // ссылки по проектам
    const navigation = {
      site: [
        {
          id: 1,
          name: 'Модули',
          slug: '/modules',
          policies: 'Modules'
        },
        {
          id: 2,
          name: 'Товары',
          slug: '/products/0',
          policies: 'Products'
        },
        {
          id: 3,
          name: 'Новости',
          slug: '/news',
          policies: 'Articles'
        }
        // {
        //   id: 4,
        //   name: 'Мероприятия',
        //   slug: '/events',
        //   policies: 'Events'
        // }
      ],
      education: [
        {
          id: 1,
          name: 'Модули',
          slug: '/modules-education',
          policies: 'Modules'
        }
        // {
        //   id: 2,
        //   name: 'Повышение квалификации',
        //   slug: '/',
        //   policies: 'Qualification'
        // },
        // {
        //   id: 3,
        //   name: 'Сведения об образовательной организации',
        //   // slug в этом объекте завязан на функционал отрисовки выпадающего списка см. функцию informationListBlockVisible
        //   slug: '/information',
        //   policies: '/'
        // },
        // {
        //   id: 4,
        //   name: 'Материалы',
        //   slug: '/materials',
        //   policies: 'Materials'
        // },
        // {
        //   id: 5,
        //   name: 'Контакты',
        //   slug: '/',
        //   policies: 'Сontacts'
        // },
        // {
        //   id: 6,
        //   name: 'Дистанционное обучение',
        //   slug: '/',
        //   policies: 'Distance'
        // },
        // {
        //   id: 7,
        //   name: 'Заявка на обучение',
        //   slug: '/application',
        //   policies: 'Application'
        // },
        // {
        //   id: 8,
        //   name: 'Новости',
        //   slug: '/news-education',
        //   policies: 'News'
        // }
      ],
      archive: [
        {
          id: 1,
          name: 'Раздел архива',
          slug: '/',
          policies: ''
        },
        {
          id: 1,
          name: 'Еще один',
          slug: '/',
          policies: ''
        }
      ]
    }
    const getNavList = computed(() => {
      // получает ссылки аткивного проекта
      return navigation[activeProject.value]
    })

    const signOut = () => {
      // разлогиниться
      store.dispatch('setSignOut')
    }

    const minimizeSidebar = computed(() => {
      return store.getters.getMinimizeSidebar
    })

    const informationListBlock = ref(false)

    const informationListItemId = ref(null)

    const informationListBlockVisible = (slug) => {
      if (getNavList.value.find(item => item.slug === slug && item.slug === '/information')) {
        informationListBlock.value = true
        informationListItemId.value = navigation.education[2].id
      } else {
        informationListBlock.value = false
        informationListItemId.value = null
      }
    }

    const informationListBlockHidden = () => {
      informationListBlock.value = false
      informationListItemId.value = null
    }

    const InformationList = ref([
      {
        name: 'Основные сведения',
        slug: '/information/basic-information'
      },
      {
        name: 'Структура и органы управления образовательной организацией',
        slug: '/information/structure'
      },
      {
        name: 'Документы',
        slug: '/information/documents'
      },
      {
        name: 'Образование',
        slug: '/information/education'
      },
      {
        name: 'Руководство. Педагогический (научно-педагогический) состав',
        slug: '/information/teachers'
      },
      {
        name: 'Материально-техническое обеспечение и оснащенность образовательного процесса',
        slug: '/information/material-support'
      },
      {
        name: 'Платные образовательные услуги',
        slug: '/information/paid-services'
      },
      {
        name: 'Финансово-хозяйственная деятельность',
        slug: '/information/financial-activities'
      },
      {
        name: 'Вакантные места для приема (перевода) обучающихся',
        slug: '/information/vacant-place'
      },
      {
        name: 'Доступная среда',
        slug: '/information/accessible-environment'
      },
      {
        name: 'Международное сотрудничество',
        slug: '/information/international-cooperation'
      }
    ])

    return {
      navigation,
      AuthData,
      policies,
      hideShowSidebar,
      activeProject,
      getNavList,
      signOut,
      activeViewLink,
      informationListBlock,
      informationListBlockVisible,
      informationListBlockHidden,
      InformationList,
      test,
      informationListItemId,
      minimizeSidebar
      // searchPolicies
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  position: relative;
  padding: 12px;
  width: 224px;
  max-height: 100%;
  z-index: 2;
  //background-color: #F5F5F5;

  &__sticky {
    position: sticky;
    top: 12px;
    height: 100%;
  }

  &__controllers {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    overflow: hidden;
    margin-bottom: 188px;
  }

  &__arrow {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #C8C8C8;
    border-radius: 6px;
    justify-content: center;
    visibility: visible;
    background-color: #FFFFFF;
    cursor: pointer;

    @media(any-hover: hover) {
      &:hover {
        background-color: #E6E6E6;
        transition: 0.5s;
      }
    }

    &:active {
      background-color: #0080B1;
      color: #FFFFFF;
      transition: 0.5s;
    }

    :deep(.wrapper) {
      position: static;
    }
  }

  &__exit {
    position: absolute;
    bottom: -30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: #00ABEC;
    padding: 6px;
    border-radius: 4px;

    @media(any-hover: hover) {
      &:hover {
        background-color: #0080B0;
        transition: 0.5s;
      }
    }

    &:active {
      background-color: #006084;
      color: #FFFFFF;
      transition: 0.5s;
    }
  }

  &__settings {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}

.person-name {
  color: #000000;
  text-align: left;

  &__first {
    font-weight: 500;
    font-size: 18px;
    max-width: 150px;
  }

  &__second {
    font-weight: 400;
    font-size: 15px;
    max-width: 150px;
  }
}

.navigation-list {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  width: 100%;
  overflow: hidden;
}
// .router-link-active {
//   background-color: #FFFFFF;
//   color: #1487B1;
//   transition: 0.5s;
// }
.wrapper {
  position: relative;
}
</style>
